import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import FeaturedReleases from './components/FeaturedReleases';
import CopyrightSection from './components/CopyrightSection';
import RilisMusikPreview from './components/RilisMusikPreview';
import RecentReleases from './components/RecentReleases';
import Partners from './components/Partners';
import Testimonials from './components/Testimonials';
import Blog from './components/Blog';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

import { AdminAuthProvider } from './lib/AdminAuth';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';

import RilisMusikPage from './pages/RilisMusikPage';
import RilisanPage from './pages/RilisanPage';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import ArtistsListPage from './pages/ArtistsListPage';
import ArtistDetailPage from './pages/ArtistDetailPage';
import KontakPage from './pages/KontakPage';

const Home = () => {
  useEffect(() => {
    document.title = 'Werdi Media — Distribusi Musik Indonesia';
  }, []);

  return (
    <div className="App bg-[#0a0a0a] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <FeaturedReleases />
        <RilisMusikPreview />
        <CopyrightSection />
        <RecentReleases />
        <Partners />
        <Testimonials />
        <Blog />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

const AdminLayout = ({ children }) => {
  useEffect(() => {
    document.title = 'Werdi Media CMS — Admin';
  }, []);
  return <AdminAuthProvider>{children}</AdminAuthProvider>;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rilis-musik" element={<RilisMusikPage />} />
        <Route path="/rilisan" element={<RilisanPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/artis" element={<ArtistsListPage />} />
        <Route path="/artis/:slug" element={<ArtistDetailPage />} />
        <Route path="/kontak" element={<KontakPage />} />
        <Route
          path="/admin/login"
          element={
            <AdminLayout>
              <AdminLogin />
            </AdminLayout>
          }
        />
        <Route
          path="/admin"
          element={
            <AdminLayout>
              <AdminDashboard />
            </AdminLayout>
          }
        />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
